import React from 'react'

const Bandcamp = ({ className, width, height }) => {
  const w = typeof width !== 'undefined' ? width : 32
  const h = typeof height !== 'undefined' ? width : 32
  return (
    <svg
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={`${w}px`}
      height={`${h}px`}
      viewBox="0 0 512 512"
      enableBackground="new 0 0 512 512"
    >
      <g id="c2be471c56fc5b4dd571614bb3052c8e">
        <path
          display="inline"
          d="M354.27,407.291H0.5l157.231-302.582H511.5L354.27,407.291z"
        ></path>
      </g>
    </svg>
  )
}

export default Bandcamp
